import { ButtonBase, Menu, MenuItem, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

import {
  addCommaToPrice,
  convertPersianNumbersToEnglishNumbers,
  removeCommaFromPrice
} from '../../../helpers/numbers'
import { getTranslate } from '../../../localization'
import useStyles from './styles/RenderInputRowCell.styles'

interface RenderInputRowCellProps {
  hoveredItem: number | null
  sethoveredItem: React.Dispatch<React.SetStateAction<number | null>>
  value: number
  isPriceType?: boolean
  index: number
  weekendIndexes: number[]
  onSaveValue?: (n: number, editedValue?: string) => void
  edited?: boolean
  maxValue?: number
}

export const percentIncreaseDecreaseRegex = /^[+-]\d+%$/

const RenderInputRowCell: React.FC<RenderInputRowCellProps> = ({
  hoveredItem,
  sethoveredItem,
  value,
  isPriceType,
  index,
  weekendIndexes,
  onSaveValue,
  edited,
  maxValue
}) => {
  const classes = useStyles()
  const [inputValue, setinputValue] = useState<string>(value.toString())
  const [error, setError] = useState(false)
  const [confirmed, setConfirmed] = useState(false)
  const [editMode, seteditMode] = useState<boolean>(false)
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null)

  const handleClose = () => {
    setAnchorEl(null)
  }
  useEffect(() => {
    setinputValue(value.toString())
  }, [value])
  let clickTimer: NodeJS.Timeout | null = null

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    let theCurrentTarget: (EventTarget & HTMLButtonElement) | null =
      event.currentTarget

    if (clickTimer !== null) {
      // Double click logic
      clearTimeout(clickTimer)
      clickTimer = null
      seteditMode(true)
    } else {
      // Single click logic
      clickTimer = setTimeout(() => {
        clickTimer = null

        setAnchorEl(theCurrentTarget)
        theCurrentTarget = null
      }, 200) // Adjust the delay (in milliseconds) as per your preference
    }
    event.stopPropagation()
  }

  const handleChangeInputValue: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    const convertedNumberToEnglishChars = convertPersianNumbersToEnglishNumbers(
      event.currentTarget.value
    )
    const commaLessValue = removeCommaFromPrice(convertedNumberToEnglishChars)
    if (isPriceType) {
      if (Number.isNaN(Number(commaLessValue))) {
        if (percentIncreaseDecreaseRegex.test(commaLessValue)) {
          setError(false)
        } else {
          setError(true)
        }
      }
      setinputValue(commaLessValue)
    } else if (Number.isNaN(Number(commaLessValue))) {
      setError(true)
    } else {
      setError(false)
      if (!maxValue || Number(commaLessValue) <= maxValue) {
        setinputValue(commaLessValue)
      }
    }
  }

  const handleSubmit = () => {
    if (value.toString() === inputValue) {
      return
    }
    setConfirmed(true)
    if (isPriceType) {
      if (Number.isNaN(Number(inputValue))) {
        if (percentIncreaseDecreaseRegex.test(inputValue)) {
          const newValue =
            value +
            value *
              (Number(inputValue.substring(1, inputValue.length - 1)) / 100) *
              (inputValue.charAt(0) === '+' ? 1 : -1)
          if (!Number.isNaN(newValue)) {
            onSaveValue?.(newValue, inputValue)
          }
        }
      } else {
        onSaveValue?.(Number(inputValue))
      }
    } else if (!Number.isNaN(Number(inputValue))) {
      onSaveValue?.(Number(inputValue))
    }
  }

  // const [resetCRSInventory] = useMutation(RESET_CRS_INVENTORY_MUTATION, {
  //   onCompleted: (resp) => {
  //     toast.success(resp.resetCRSInventory.message)
  //     refetchRoomtypeList()
  //   },
  //   onError: (err) => {
  //     toast.error(err.message)
  //   }
  // })
  // const [resetChannelInventory] = useMutation(
  //   RESET_CHANNEL_INVENTORY_MUTATION,
  //   {
  //     onCompleted: (resp) => {
  //       toast.success(resp.resetChannelInventory.message)
  //       refetchRoomtypeList()
  //     },
  //     onError: (err) => {
  //       toast.error(err.message)
  //     }
  //   }
  // )

  return (
    <div
      className={[
        classes.dayContainer,
        isPriceType ? classes.priceDayContianer : '',
        hoveredItem === index ? classes.selectedDayContainer : '',
        weekendIndexes.includes(index % 7) ? classes.weekendDayContainer : '',
        confirmed && error ? classes.dayContainerWithError : '',
        edited ? classes.editedDayContainer : ''
      ].join(' ')}>
      <div>
        {editMode ? (
          <input
            value={
              Number.isNaN(Number(inputValue))
                ? inputValue
                : addCommaToPrice(inputValue)
            }
            onChange={handleChangeInputValue}
            onClick={(e) => {
              sethoveredItem(index)
              e.currentTarget.select()
            }}
            onKeyUp={(event) => {
              if (event.key === 'Enter' || event.key === 'Tab') {
                handleSubmit()
              }
            }}
            onBlur={() => {
              sethoveredItem(null)
              if (error) {
                setinputValue(value.toString())
                setError(false)
              } else {
                handleSubmit()
                seteditMode(false)
              }
            }}
          />
        ) : (
          <ButtonBase onClick={handleClick}>
            <Typography variant="body1" className={classes.NotEditing}>
              {Number.isNaN(Number(inputValue))
                ? inputValue
                : addCommaToPrice(inputValue)}
            </Typography>
          </ButtonBase>
        )}
      </div>{' '}
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}>
        <MenuItem onClick={() => {}} disabled>
          {getTranslate('reset')}
        </MenuItem>
        <MenuItem onClick={() => {}} disabled>
          {getTranslate('copy')}
        </MenuItem>
      </Menu>
    </div>
  )
}

export default RenderInputRowCell
